'use strict';
/**
 * Migration steps for % Based Pricing each stage is mapped to a database entry
 * For more information please see: https://confluence.godaddy.com/x/gHWWDg
 */

module.exports = {
  NOT_STARTED: 0,
  OVERVIEW: 1,
  GLOBAL_PRICING: 2,
  PRODUCT_PRICING: 3,
  PROMOTIONS: 4,
  REVIEW: 5,
  MIGRATED: 6
};